export enum NotificationType {
	INSTALL_APPLE = 'installApple',
	INSTALL_ANDROID = 'installAndroid',
	PUSH_NOTIFICATION_ALERT = 'pushNotificationAlert',
	NOTIFICATION_OFF = 'permissionDenied',
	SUBSCRIPTION_ERROR = 'subscriptionError',
}

export enum DeviceType {
	BROWSER = 'BROWSER',
}

export enum BrowserType {
	EDGE = 'Edge',
	CHROME = 'Chrome',
	FIREFOX = 'Firefox',
	SAFARI = 'Safari',
}

export const BrowserFullNames = {
	[BrowserType.EDGE]: 'Microsoft Edge',
	[BrowserType.CHROME]: 'Google Chrome',
	[BrowserType.FIREFOX]: 'Mozilla Firefox',
	[BrowserType.SAFARI]: 'Safari',
};

export enum NotificationPermission {
	DEFAULT = 'default',
	GRANTED = 'granted',
	DENIED = 'denied',
}

type PopUpConfig = {
	DISPLAY_DURATION: number;
	DELAY_TIME: Partial<Record<NotificationType, number>>;
};

export const POPUP_CONFIG: PopUpConfig = {
	DISPLAY_DURATION: 10000,
	DELAY_TIME: {
		[NotificationType.PUSH_NOTIFICATION_ALERT]: 2000,
		[NotificationType.INSTALL_ANDROID]: 2000,
		[NotificationType.NOTIFICATION_OFF]: 0,
		[NotificationType.SUBSCRIPTION_ERROR]: 0,
	},
};
